import { render, staticRenderFns } from "./ArtWorks.vue?vue&type=template&id=b9524106&"
import script from "./ArtWorks.vue?vue&type=script&lang=js&"
export * from "./ArtWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports